import React from 'react'

const List = function List(props) {
    return (
        <div className={'list'} style={props.style}>{props.children}</div>
    )
}

export { List };
